
import React, {useState, useEffect} from 'react';
import { AppBar, Toolbar, IconButton, Typography, MenuItem, Menu } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {getStore} from '../util/index.js'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { createTheme, alpha } from '@mui/material/styles';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import EditIcon from '@mui/icons-material/Edit';
import EditProfile from './editProfile.js'

const styleObj = {
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 2,
  },
  title: {
    display: 'block'
  },
  search: {
    position: 'relative',
    borderRadius: 1,
    backgroundColor: alpha('rgb(256, 256, 256)', 0.15),
    '&:hover': {
      backgroundColor: alpha('rgb(256, 256, 256)', 0.25),
    },
    marginRight: 2,
    marginLeft: {xs:3, sm: 3},
    width: {xs:'auto', sm: 'auto',  md: '100%', lg: '100%', xl:'100%'}
  
  },
  searchIcon: {
    padding: '0 2',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: '1, 1, 1, 0',
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + 4px)`,
    width: {xs:'100%', sm: '100%', md: '20ch', lg: '20ch', xl:'20ch'},
  },
  sectionDesktop: {
    display: {xs: 'none', sm:'none', md: 'flex',  lg: 'flex', xl:'flex'}
  },
  container: {
    width:'100%'
  },
  sectionMobile: {
    display: {xs: 'flex', sm:'flex', md: 'none',  lg: 'none', xl:'none'}
  },
};

const theme = createTheme();

export default function PrimarySearchAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState()

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handler = (e) => {
      console.log("insalltin", e)
      // Stop the mini-infobar from appearing on mobile
      e.preventDefault();
      // Save the event so it can be triggered later
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    // Cleanup
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);
  console.log(isInstallable)
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  }

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };


  const handleInstallClick = async() => {
    console.log(isInstallable)
    if (!deferredPrompt) return;

    // Show the browser install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to install prompt: ${outcome}`);

    // Optionally, disable the button if they installed or dismissed
    setDeferredPrompt(null);
    setIsInstallable(false);

  }
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
     <MenuItem onClick={()=>{ setShowEditProfile(true); handleMenuClose() }}>
        <EditIcon sx={{mr: 1}}/>
        Edit Profile
      </MenuItem>
      <MenuItem onClick={handleInstallClick}>
        <InstallMobileIcon sx={{mr: 1}}/>
        Install
      </MenuItem>
       <MenuItem onClick={handleLogout}>
        <PowerSettingsNewIcon sx={{mr: 1}}/>
        Logout
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
     <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );

  return (

      <div style={styleObj.container}>
        <AppBar position="static">
          <Toolbar>

            <Typography sx={styleObj.title} variant="h6" noWrap>
              {getStore('user')?.user?.storeName}
            </Typography>

            <div style={styleObj.grow} />
            <div style={styleObj.sectionDesktop}>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMenu}
        {showEditProfile && (<EditProfile open={showEditProfile} handleClose={()=>{setShowEditProfile(false)}}/>)}
      </div>
  );
}
